import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import { formatDateTime, startLoader, stopLoader, validateEmail } from '../../../lib/utils';
import { createGymEnquiry, updateGymEnquiry } from '../helper/api';
import { isAuthenticated } from '../../../auth';
import Toast from "../../../lib/toast";
import { getUserInfo, getUsersList, getUsersListV2 } from '../../employees/helper/api';
import {getEnquiryByID} from '../helper/api';
import { getBranch } from '../../gyms/helper/api';
import "../style.scss";
import { saveFollowup } from '../../follow-up/helper/api';

const ManageEnquiry = (props) => {

  const birthDateRef = useRef(null);
  const anniversaryDateRef = useRef(null);
  const commitmentDateRef = useRef(null); 
  const trialDateAndTimeRef = useRef(null);
  const [Users,setUsers]=useState([]);

  const [isGymServiceListOpen, setGymServiceListOpen] = useState(false);
  const [isTrialBooking, setTrialBooking] = useState(false);
  const [isAssignToListOpen, setAssignToListOpen] = useState(false);
  const [isLeadTypeOpen, setLeadTypeOpen] = useState(false);
  const [isReferralUserListOpen, setReferralUserListOpen] = useState(false);
  const [isLeadSourceListOpen, setLeadSourceListOpen] = useState(false);
  const [isPersonalityTypeListOpen, setPersonalityTypeListOpen] = useState(false);
  const [isBulkUpload, setBulkUpload] = useState(false);
  const [bulkUploadedFile, setBulkUploadedFile] = useState("");

  const [currentElementId, setCurrentElementId] = useState("");
  const [progressTracker, setProgressTracker] = useState({
    personalInfo : false,
    gymService: false,
    leadsInfo: false
  });

  const [userEnqDetails, setUserEnqDetails] = useState({
    name: {
      firstName: "",
      middleName: "",
      lastName: ""
    },
    personalDetails: {
      birthDate: "",
      gender: "",
      maritalStatus: "",
      anniversaryDate: ""
    },
    contactDetails: {
      mobileNumber: "",
      landLineNumber: "",
      emergencyContactPerson: "",
      emergencyContactNumber: "",
      emailAddress: "",
      residentialAddress: "",
      apartmentName: ""
    },
    personalFitnessStatus: {
      healthChallenges: "",
      fitnessGoal: "",
      exercising: null
    },
    gymPrefService: {
      gymService: "",
      commitmentDate: "",
    },
    trialBooking:{
      trialDateAndTime: "",
      assignTo: ""
    },
    leadAndReferral: {
      leadType: "",
      memberEmployeeReferral: "",
      otherReferral: "",
      leadSource: ""
    },
    personalTraitAndBudget: {
      personalityType: "",
      budget: ""
    },
    remark: ""
  })


  const [isButtonLock,setButtonLock] = useState(false)
  const { user, token } = isAuthenticated();
  const [Branch,setBranch] = useState("");
  const [enquiryType, setEnquiryType] = useState("");
  const [selectedEnq, setSelectedEnq] = useState("");

  const [isAddNewFollowup, setAddNewFollowup] = useState(false);
  const followUpDateRef = useRef(null);
  const [followUps, setFollowUps] = useState({
    followUpDate: "",
    followUpDateDisplay: "",
    followUpType: "",
    todo: "",
    assignTo: "",
    convertibility: ""
  });
  const [isFollowUpTypeListOpen, setFollowUpTypeListOpen] = useState(false);
  const [isAssignToUserListOpen, setAssignToUserListOpen] = useState(false);
  const [isFollowUpConvertibilityTypeOpen, setFollowUpConvertibilityTypeOpen] = useState(false);
  


  const GetBranch = async branchId =>{
    try{
      const response = await getBranch(user._id,token,branchId);
      if(response.error){

      }else{
        setBranch(response);
      }

    }catch(error){
      
    }
  }

  const GetUsers = async (isReload) =>{
    try{
      //await startLoader();
      // const params = {
      //   noLimit:"noLimit",
      //   isAllUser:true
      // };

      // params.activationStatus = "activate";
      // if (Branch) params.gymIDs = [Branch.gymId];
      // if (Branch) params.branchIDs = Branch._id;

      // const response = await getUsersListV2(user._id,token,params);
      // setUsers(response.error?[]:response);

      const params = {
        noLimit:"noLimit",
        isAllUser:true,
        branchIDs:[Branch._id],
        roles:[0,1,4,11,9,3]
      }

      // if(searchKey) params.q=searchKey;

      const response = await getUsersListV2(user._id,token,params);
      if(!response.error){
        setUsers(isReload?response:[...Users,...response]);
      }

    }catch(error){
      console.log(error)
    }
    //await stopLoader()
  }


  const SaveEnquiry = async event =>{
    try{
      await startLoader()
      setButtonLock(true)

      if(!Branch?._id){
        new Toast({
          type:"error",
          message:"Branch should be selected",
          duration:1000
        })
      }

      const payload = {
        userInfo:{
          first_name:userEnqDetails.name.firstName,
          middle_name:userEnqDetails.name.middleName,
          last_name:userEnqDetails.name.lastName,
          full_name:`${userEnqDetails.name.firstName} ${userEnqDetails.name.middleName} ${userEnqDetails.name.lastName}`,
          email:userEnqDetails.contactDetails.emailAddress,
          phone:userEnqDetails.contactDetails.mobileNumber,
          countryCode:91,
          isPhoneNumberVerified:false,
          land_line_number:userEnqDetails.contactDetails.landLineNumber,
          gender:userEnqDetails.personalDetails.gender,
          address:userEnqDetails.contactDetails.residentialAddress + ", " + userEnqDetails.contactDetails.apartmentName,
          date_of_birth:userEnqDetails.personalDetails.birthDate,
          date_of_birth_string:formatDateTime(userEnqDetails.personalDetails.birthDate),
          anniversary_date:userEnqDetails.personalDetails.anniversaryDate,
          anniversary_date_string:formatDateTime(userEnqDetails.personalDetails.anniversaryDate),
          marital_status:userEnqDetails.personalDetails.maritalStatus,
          emergency_contact_person:userEnqDetails.contactDetails.emergencyContactPerson,
          emergency_contact_no:userEnqDetails.contactDetails.emergencyContactNumber,
          residential_address:userEnqDetails.contactDetails.residentialAddress,
          apartment_name:userEnqDetails.contactDetails.apartmentName
        },
        health_challenges:userEnqDetails.personalFitnessStatus.healthChallenges,
        fitness_goal:userEnqDetails.personalFitnessStatus.fitnessGoal,
        lead_type:userEnqDetails.leadAndReferral.leadType,
        budget:userEnqDetails.personalTraitAndBudget.budget,
        lead_source:userEnqDetails.leadAndReferral.leadSource,
        personalityType:userEnqDetails.personalTraitAndBudget.personalityType,
        member_employee_referral:userEnqDetails.leadAndReferral.memberEmployeeReferral?._id,
        other_referral:userEnqDetails.leadAndReferral.otherReferral,
        currently_exercising:userEnqDetails.personalFitnessStatus.exercising,
        gym_service:userEnqDetails.gymPrefService.gymService,
        commitment_date:userEnqDetails.gymPrefService.commitmentDate,
        sourceOfEnquiry: userEnqDetails.leadAndReferral.leadSource ? userEnqDetails.leadAndReferral.leadSource : "Walk-In",
        type:"Gym Enquiry",
        book_a_trial:isTrialBooking,
        remark:userEnqDetails.remark,
        gymId:Branch.gymId,
        branchId:Branch._id
      };

      if(isTrialBooking){
        payload.assign_to=userEnqDetails.trialBooking.assignTo?._id;
        payload.trial_date_and_time = userEnqDetails.trialBooking.trialDateAndTime;
        payload.assignedTo={
          first_name:`${userEnqDetails.trialBooking.assignTo?.name || ""}`.split(" ")[0],
          middle_name:"",
          last_name:`${userEnqDetails.trialBooking.assignTo?.name || ""}`.length>0? `${userEnqDetails.trialBooking.assignTo?.name || ""}`.split(" ")[1]:"",
          mobile_number:userEnqDetails.trialBooking.assignTo?.phone,
          email:userEnqDetails.trialBooking.assignTo?.email,
          profileId:userEnqDetails.trialBooking.assignTo?.profileId,
          user_id:userEnqDetails.trialBooking.assignTo?._id
        };
      }

      let response;

      if (props.selectedUsers) {
        response = await updateGymEnquiry(user._id, token, props.selectedUsers._id, payload);
      } else {
        response = await createGymEnquiry(user._id, token, payload);
      }
      
      if(response.error){
        console.log(response.error)
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{

        if(isAddNewFollowup && followUps.followUpDate != "" && followUps.followUpType != "" && followUps.todo != "" && followUps.assignTo != "" && followUps.convertibility != "" && response._id){
          SaveFollowUp(response._id);
        }

        if(isAddNewFollowup && !response._id){
          new Toast({
            type:"error",
            duration:3000,
            message:"Follow-up failed: Unable to find enquiry"
          })
        }

        if(enquiryType == "new-sales"){


          try{
            // console.log(response);
            // console.log(response._id);

            const getEnqByID = await getEnquiryByID(user._id, token, response._id);

            if(!getEnqByID.error){
              setSelectedEnq(getEnqByID);
            }else{
              props.handleCloseModal();
              new Toast({
                type:'warning',
                message:"Enquiry Created, but not able to close membership",
                duration:3000
              })
            }
          }catch(err){
            console.log(err);
          }

        }else{

          if (props.selectedUsers) {
            new Toast({
              type:"success",
              duration:3000,
              message:"Enquiry Updated Successfully"
            })
          }else{
            new Toast({
              type:"success",
              duration:3000,
              message:"Successfully enquiry created"
            })
          }
          
          props.handleCloseModal();
          if(props.reloadEnquiry) props.reloadEnquiry(); 
        }
      }

      setButtonLock(false)
      await stopLoader();
    }catch(error){
      setButtonLock(false)
      await stopLoader()
    }
  }

  const SaveFollowUp = async(enqId) => {
    try{
      await startLoader();
      setButtonLock(true)
      const payload = {
        assigned_to_id:followUps.assignTo?._id,
        scheduled_type:"Enquiry",
        creation_type:"Manual",
        to_do:followUps.todo,
        followable_type: followUps.followUpType,
        date:followUps.followUpDate,
        dateString:formatDateTime(followUps.followUpDate),
        convertibility: followUps.convertibility.toLowerCase(),
        enquiryIDs:enqId
      };
  
      const response = await saveFollowup(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Followup created successfully"
        });
        props.handleCloseModal();
        if(props.reloadFollowup) props.reloadFollowup();
      }
    }catch(error){
      
    }
    await stopLoader();
  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }

    if(id == "gym-service"){
      setGymServiceListOpen(!isGymServiceListOpen)
    }

    if(id == "assign-to-employee"){
      setAssignToListOpen(!isAssignToListOpen)
    }

    if(id == "lead-type"){
      setLeadTypeOpen(!isLeadTypeOpen)
    }

    if(id == "user-referral"){
      setReferralUserListOpen(!isReferralUserListOpen)
    }

    if(id == "lead-source"){
      setLeadSourceListOpen(!isLeadSourceListOpen)
    }

    if(id == "personality-type"){
      setPersonalityTypeListOpen(!isPersonalityTypeListOpen)
    }

    if(id == "followup-type"){
      setFollowUpTypeListOpen(!isFollowUpTypeListOpen)
    }

    if(id == "assign-to"){
      setAssignToUserListOpen(!isAssignToUserListOpen)
    }

    if(id == "convertibility-followup-type"){
      setFollowUpConvertibilityTypeOpen(!isFollowUpConvertibilityTypeOpen)
    }
  }

  const handleChange = (event) => {
    if(currentElementId == "first-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          firstName: event.target.value
        }
      }));
    }
    if(currentElementId == "middle-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          middleName: event.target.value
        }
      }));
    }
    if(currentElementId == "last-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          lastName: event.target.value
        }
      }));
    }
    if (currentElementId === "mobile-number") {
      const value = event.target.value;

      const numericValue = value.replace(/\D/g, "");

      if (numericValue.length <= 10) {
        setUserEnqDetails(prev => ({
          ...prev,
          contactDetails: {
            ...prev.contactDetails,
            mobileNumber: numericValue
          }
        }));
      }else{
        new Toast({
          type:'warning',
          message:"Phone No. cannot exceed 10 digits",
          duration:3000
        })
      }
    }
    if(currentElementId == "landline-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          landLineNumber : event.target.value
        }
      }))
    }
    if(currentElementId == "email-address"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emailAddress : event.target.value
        }
      }))
    }
    if(currentElementId == "other-referral"){
      setUserEnqDetails(prev => ({
        ...prev,
        leadAndReferral: {
          ...prev.leadAndReferral,
          otherReferral : event.target.value
        }
      }))
    }
    if(currentElementId == "residential-address"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          residentialAddress : event.target.value
        }
      }))
    }
    if(currentElementId == "budget"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalTraitAndBudget: {
          ...prev.personalTraitAndBudget,
          budget : event.target.value
        }
      }))
    }
    if(currentElementId == "apartment-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          apartmentName : event.target.value
        }
      }))
    }
    if(currentElementId == "health-challenges"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalFitnessStatus: {
          ...prev.personalFitnessStatus,
          healthChallenges : event.target.value
        }
      }))
    }
    if(currentElementId == "fitness-goal"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalFitnessStatus: {
          ...prev.personalFitnessStatus,
          fitnessGoal : event.target.value
        }
      }))
    }
    
    if(currentElementId == "emergency-contact-person"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emergencyContactPerson : event.target.value
        }
      }))
    }

    if(currentElementId == "emergency-contact-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emergencyContactNumber : event.target.value
        }
      }))
    }

    if(currentElementId == "user-referral"){
      setUserEnqDetails(prev => ({
        ...prev,
        leadAndReferral: {
          ...prev.leadAndReferral,
          memberEmployeeReferral: event.target.value
        }
      }))
    }
    
    if(currentElementId == "remark"){
      setUserEnqDetails(prev => ({
        ...prev,
        remark: event.target.value
      }))
    }

    if(currentElementId == "followup-todo"){
      setFollowUps(prev => ({
        ...prev,
        todo: event.target.value
      }))
    }

  }


  const handleSelectDropdownItem = (type, value) => {
    if(type == "gym-service"){
      setUserEnqDetails(prev => ({
        ...prev,
        gymPrefService: {
          ...prev.gymPrefService,
          gymService: value
        }
      }))
      setGymServiceListOpen(false)
    }

    if(type == "assign-to-employee"){
      setUserEnqDetails(prev => ({
        ...prev,
        trialBooking: {
          ...prev.trialBooking,
          assignTo: value
        }
      }))
      setAssignToListOpen(false)
    }

    if(type == "lead-type"){
      setUserEnqDetails(prev => ({
        ...prev,
        leadAndReferral: {
          ...prev.leadAndReferral,
          leadType: value
        }
      }))
      setAssignToListOpen(false)
    }

    if(type == "user-referral"){
      setUserEnqDetails(prev => ({
        ...prev,
        leadAndReferral: {
          ...prev.leadAndReferral,
          memberEmployeeReferral: value
        }
      }))
      setReferralUserListOpen(false)
    }

    if(type == "lead-source"){
      setUserEnqDetails(prev => ({
        ...prev,
        leadAndReferral: {
          ...prev.leadAndReferral,
          leadSource: value
        }
      }))
      setLeadSourceListOpen(false)
    }

    if(type == "personality-type"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalTraitAndBudget: {
          ...prev.personalTraitAndBudget,
          personalityType: value
        }
      }))
      setPersonalityTypeListOpen(false)
    }

    if(type == "followup-type"){
      setFollowUps(prev => ({
        ...prev,
        followUpType: value
      }))
    }

    if(type == "assign-to"){
      setFollowUps(prev => ({
        ...prev,
        assignTo: value
      }))
    }

    if(type == "convertibility-followup-type"){
      setFollowUps(prev => ({
        ...prev,
        convertibility: value
      }))
    }
  }

  const toggleTrialBooking = () => {
    setTrialBooking(!isTrialBooking)
  }

  const handleRadioAction = (type, value) => {
    if(type == "gender"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalDetails: {
          ...prev.personalDetails,
          gender: value
        }
      }))
    }

    if(type == "marital-status"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalDetails: {
          ...prev.personalDetails,
          maritalStatus: value
        }
      }))
    }

    if(type == "exercising"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalFitnessStatus: {
          ...prev.personalFitnessStatus,
          exercising: value
        }
      }))
    }
  }

  const toggleBulkUpload = () => {
    setBulkUpload(!isBulkUpload)
  }

  const handleScrollUserList = () => {
    
  }

  const handleAddNewFollowup = () => {
    setAddNewFollowup(!isAddNewFollowup)
  }


  useEffect(() => {
    if(selectedEnq != "" && enquiryType == "new-sales"){
      props.handleNewSale(selectedEnq);
      props.handleCloseModal();
    }
  },[selectedEnq])


  useEffect(async () => {


    try{
      const branchId = localStorage.getItem("branchId");
      if(branchId){
        await startLoader();
        await GetBranch(branchId)
        await stopLoader();
      }

    }catch(error){
      await stopLoader();
    }
   
    const birthdayPicker = flatpickr(birthDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUserEnqDetails(prev => ({
          ...prev,
          personalDetails: {
            ...prev.personalDetails,
            birthDate: istDate
          }
        }));
      }
    });

    const anniversaryDate = flatpickr(anniversaryDateRef.current, {
      dateFormat: "Y-m-d",
      disableMobile: true,
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUserEnqDetails(prev => ({
          ...prev,
          personalDetails: {
            ...prev.personalDetails,
            anniversaryDate: istDate
          }
        }))
      }
    })

    const commitmentDate = flatpickr(commitmentDateRef.current, {
      dateFormat: "Y-m-d",
      disableMobile: true,
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUserEnqDetails(prev => ({
          ...prev,
          gymPrefService: {
            ...prev.gymPrefService,
            commitmentDate: istDate
          }
        }))
      }
    })
  
    return () => {
      birthdayPicker.destroy();
      anniversaryDate.destroy();
      commitmentDate.destroy();
    }
  }, []);

  useEffect(() => {
    if (!isAddNewFollowup || !followUpDateRef.current) return;

    const picker = flatpickr(followUpDateRef.current, {
      dateFormat: "Y-m-d h:i K",
      enableTime: true,
      time_24hr: false,
      defaultDate: new Date(),
      disableMobile: true,
      onChange: ([date]) => {
        const isoString = date.toISOString();

        const displayString = date.toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });

        setFollowUps(prev => ({
          ...prev,
          followUpDate: isoString, 
          followUpDateDisplay: displayString
        }));
      }
    });

    return () => {
      picker.destroy();
    };

  }, [isAddNewFollowup]);


  useEffect(() => {
    if (!isTrialBooking || !trialDateAndTimeRef.current) return;

    const picker = flatpickr(trialDateAndTimeRef.current, {
      enableTime: true,
      disableMobile: true,
      dateFormat: "Y-m-d H:i",
      onChange: ([date]) => {
        if (date) {
          const istDate = date.toLocaleDateString('en-CA', {
            timeZone: 'Asia/Kolkata'
          });
          setUserEnqDetails(prev => ({
            ...prev,
            trialBooking: {
              ...prev.trialBooking,
              trialDateAndTime: istDate
            }
          }));
        }
      }
    });

    return () => picker.destroy();
  }, [isTrialBooking]);
  

  useEffect(() => {
    if(userEnqDetails.name.firstName && userEnqDetails.contactDetails.mobileNumber){
      setProgressTracker(prev => ({
        ...prev,
        personalInfo: true
      }));
    }else{
      setProgressTracker(prevData => ({
        ...prevData,
        personalInfo: false
      }))
    }

    if(userEnqDetails.gymPrefService.gymService){
      setProgressTracker(prev => ({
        ...prev,
        gymService: true
      }));
    }else{
      setProgressTracker(prev => ({
        ...prev,
        gymService: false
      }));
    }

     if(userEnqDetails.leadAndReferral.leadType){
      setProgressTracker(prev => ({
        ...prev,
        leadsInfo: true
      }));
    }else{
      setProgressTracker(prev => ({
        ...prev,
        leadsInfo: false
      }));
    }
  },[userEnqDetails]);

  useEffect(()=>{
    if(Branch){
      GetUsers();
    }
  },[Branch]);

  useEffect(() => {
    
    setUserEnqDetails(prev => ({
      ...prev,
      contactDetails:{
        ...prev.contactDetails,
        mobileNumber:props.phoneNo
      }
    }));

  },[props.phoneNo]);

  useEffect(() => {
    if(props.type){
      setEnquiryType(props.type)
    }
  },[props.type]);
  
  useEffect(() => {
    if (!props.selectedUsers) return;

    const data = props.selectedUsers;
    const userInfo = data.userInfo;

    const fetchReferralAndSet = async () => {
      let memberEmployeeReferral = "";

      if (data.member_employee_referral) {
        try {
          const getSelectedUser = await getUserInfo(user._id, token, data.member_employee_referral);
          if (!getSelectedUser.error) {
            memberEmployeeReferral = getSelectedUser;
          }
        } catch (err) {
          console.log(err);
        }
      }

      // Single setUserEnqDetails call — no stale state issue
      setUserEnqDetails({
        name: {
          firstName: userInfo.first_name || "",
          middleName: userInfo.middle_name || "",
          lastName: userInfo.last_name || ""
        },
        personalDetails: {
          birthDate: userInfo.date_of_birth_string || "",
          gender: userInfo.gender || "",
          maritalStatus: userInfo.marital_status || "",
          anniversaryDate: userInfo.anniversary_date_string || ""
        },
        contactDetails: {
          mobileNumber: userInfo.phone || "",
          landLineNumber: userInfo.land_line_number || "",
          emergencyContactPerson: userInfo.emergency_contact_person || "",
          emergencyContactNumber: userInfo.emergency_contact_no || "",
          emailAddress: userInfo.email || "",
          residentialAddress: userInfo.residential_address || "",
          apartmentName: userInfo.apartment_name || ""
        },
        personalFitnessStatus: {
          healthChallenges: data.health_challenges || "",
          fitnessGoal: data.fitness_goal || "",
          exercising: data.currently_exercising ?? null
        },
        gymPrefService: {
          gymService: data.gym_service || "",
          commitmentDate: data.commitment_date || ""
        },
        trialBooking: {
          trialDateAndTime: "",
          assignTo: ""
        },
        leadAndReferral: {
          leadType: data.lead_type || "",
          memberEmployeeReferral: memberEmployeeReferral, // ✅ resolved before setState
          otherReferral: data.other_referral || "",
          leadSource: data.lead_source || ""
        },
        personalTraitAndBudget: {
          personalityType: data.personalityType || "",
          budget: data.budget || ""
        },
        remark: data.remark || ""
      });
    };

    fetchReferralAndSet();
  }, [props.selectedUsers]);

  useEffect(() => {
    if (Users.length > 0) {
      const matchedUser = Users.find(
        data => data._id.toString() === user?._id?.toString()
      );

      if (matchedUser) {
        setFollowUps(prev => ({
          ...prev,
          assignTo: matchedUser
        }));
      }
    }
  }, [isAddNewFollowup]);
  
  // useEffect(() => {
  //   // if(isAddNewFollowup == true){
  //   //   setFollowUps(prev => ({
  //   //     ...prev,
  //   //     followUpDate: formatDateTime(new Date())
  //   //   }))
  //   // }
  // },[isAddNewFollowup])

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item" style={{width: window.innerWidth > 767 && isBulkUpload ? "30%" : window.innerWidth > 767 && "54%", height: window.innerWidth > 767 && "94%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <p className="flex-item fs-22 font-weight-600 color-white m-l-5">{enquiryType == "new-sales" ? "New Sale" : "New Enquiry"}</p>
              <div className='flex-item d-flex'> 
                {/* TODO */}
                <div onClick={()=>toggleBulkUpload()} className='global-button-container button-red flex-item d-flex m-r-12' style={{background: isBulkUpload && "#720B0B"}}>
                  <p className='flex-item' style={{fontWeight:"600", color: isBulkUpload && "#ffffff"}}>Bulk Upload</p>
                  {
                    isBulkUpload && (
                      <svg className="flex-item m-l-12" width="16" height="16" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
                      </svg>
                    )
                  }
                </div>
                <div onClick={props.handleCloseModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                  <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                  </svg>
                </div>
              </div>
            </div>
          )
        }

        {
          isBulkUpload ? (
            <div className="w-full" style={{height: window.innerWidth > 767 ? "83%" : "100%", padding:"0 16px 100px 16px", overflowY:"auto"}}>
              <div className='d-flex w-full m-t-20 m-b-20' style={{position:"relative", height:"50%", border:"1px dashed #9a9a9a", background:"#ffffff", borderRadius:"20px"}}>
                <div className='flex-item margin-auto'>
                  <div className='w-full d-flex'>
                    <svg className='flex-item margin-auto' width="50" height="50" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.5 2.13C2.5 1.36 3.36 0.5 4.12 0.5H13.88C14.64 0.5 15.5 1.36 15.5 2.13V11.88C15.5 12.64 14.64 13.5 13.88 13.5H4.13C3.36 13.5 2.5 12.64 2.5 11.88M0.5 4.5L4.5 9.5M4.5 4.5L0.5 9.5" stroke="#A6DA95" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.5 4.5V9.5M7.5 6.5H12.5M7.5 4.5H12.5V9.5H7.5V4.5Z" stroke="#A6DA95" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <p className='flex-item margin-auto m-t-12 font-weight-600'>Upload Excel file</p>
                </div>
                <input className='flex-item w-full h-full cursor-pointer' style={{position:"absolute", zIndex:4}} accept=".xls,.xlsx,.xlsm" type="file" />
              </div>
              <div className='d-flex'>
                <div className='d-flex global-button-container global-button-container-active'>
                  <p className='flex-item'>Download File Structure</p>
                </div>
              </div>
            </div>
          ) : [
            <div className='progress-bar-scroll-container d-flex w-full m-b-20 p-l-20 p-t-20 p-r-20'>
              {
                progressTracker.personalInfo == true ? (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#5d883c"/>
                    <path d="M5 11L7.5 14L15 7" stroke="white" stroke-linecap="round"/>
                  </svg>
                ) : (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1986 19.5627C5.03467 19.5627 0.833984 15.362 0.833984 10.1981C0.833984 5.03418 5.03467 0.833496 10.1986 0.833496C15.3625 0.833496 19.5631 5.03418 19.5631 10.1981C19.5631 15.362 15.3625 19.5627 10.1986 19.5627ZM10.1986 2.17129C5.77046 2.17129 2.17178 5.76997 2.17178 10.1981C2.17178 14.6262 5.77046 18.2249 10.1986 18.2249C14.6267 18.2249 18.2254 14.6262 18.2254 10.1981C18.2254 5.76997 14.6267 2.17129 10.1986 2.17129Z" fill="#000000"/>
                    <path d="M12.8747 13.5424C12.7543 13.5424 12.6339 13.5156 12.5269 13.4487L9.18241 11.442C9.0838 11.382 9.00241 11.2975 8.94615 11.1967C8.88988 11.0959 8.86067 10.9822 8.86134 10.8668V5.51558C8.86134 5.141 9.15565 4.84668 9.53024 4.84668C9.90482 4.84668 10.1991 5.141 10.1991 5.51558V10.4922L13.2226 12.2982C13.3471 12.3745 13.4433 12.4894 13.4967 12.6253C13.5501 12.7613 13.5577 12.9109 13.5184 13.0516C13.4791 13.1923 13.395 13.3163 13.2788 13.4049C13.1626 13.4934 13.0208 13.5417 12.8747 13.5424Z" fill="#000000"/>
                  </svg>
                )
              }
              <p className='flex-item fs-16 font-weight-700' style={{whiteSpace:"nowrap"}}>Personal Info</p>
              <div className='enq-progress-line flex-item m-r-16 m-l-16'/>
              {
                progressTracker.gymService == true ? (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#5d883c"/>
                    <path d="M5 11L7.5 14L15 7" stroke="white" stroke-linecap="round"/>
                  </svg>
                ) : (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1986 19.5627C5.03467 19.5627 0.833984 15.362 0.833984 10.1981C0.833984 5.03418 5.03467 0.833496 10.1986 0.833496C15.3625 0.833496 19.5631 5.03418 19.5631 10.1981C19.5631 15.362 15.3625 19.5627 10.1986 19.5627ZM10.1986 2.17129C5.77046 2.17129 2.17178 5.76997 2.17178 10.1981C2.17178 14.6262 5.77046 18.2249 10.1986 18.2249C14.6267 18.2249 18.2254 14.6262 18.2254 10.1981C18.2254 5.76997 14.6267 2.17129 10.1986 2.17129Z" fill="#000000"/>
                    <path d="M12.8747 13.5424C12.7543 13.5424 12.6339 13.5156 12.5269 13.4487L9.18241 11.442C9.0838 11.382 9.00241 11.2975 8.94615 11.1967C8.88988 11.0959 8.86067 10.9822 8.86134 10.8668V5.51558C8.86134 5.141 9.15565 4.84668 9.53024 4.84668C9.90482 4.84668 10.1991 5.141 10.1991 5.51558V10.4922L13.2226 12.2982C13.3471 12.3745 13.4433 12.4894 13.4967 12.6253C13.5501 12.7613 13.5577 12.9109 13.5184 13.0516C13.4791 13.1923 13.395 13.3163 13.2788 13.4049C13.1626 13.4934 13.0208 13.5417 12.8747 13.5424Z" fill="#000000"/>
                  </svg>
                )
              }
              <p className='flex-item fs-16 font-weight-700' style={{whiteSpace:"nowrap"}}>Gym Services</p>
              <div className='enq-progress-line flex-item m-r-16 m-l-16'/>
              {
                progressTracker.leadsInfo == true ? (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#5d883c"/>
                    <path d="M5 11L7.5 14L15 7" stroke="white" stroke-linecap="round"/>
                  </svg>
                ) : (
                  <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1986 19.5627C5.03467 19.5627 0.833984 15.362 0.833984 10.1981C0.833984 5.03418 5.03467 0.833496 10.1986 0.833496C15.3625 0.833496 19.5631 5.03418 19.5631 10.1981C19.5631 15.362 15.3625 19.5627 10.1986 19.5627ZM10.1986 2.17129C5.77046 2.17129 2.17178 5.76997 2.17178 10.1981C2.17178 14.6262 5.77046 18.2249 10.1986 18.2249C14.6267 18.2249 18.2254 14.6262 18.2254 10.1981C18.2254 5.76997 14.6267 2.17129 10.1986 2.17129Z" fill="#000000"/>
                    <path d="M12.8747 13.5424C12.7543 13.5424 12.6339 13.5156 12.5269 13.4487L9.18241 11.442C9.0838 11.382 9.00241 11.2975 8.94615 11.1967C8.88988 11.0959 8.86067 10.9822 8.86134 10.8668V5.51558C8.86134 5.141 9.15565 4.84668 9.53024 4.84668C9.90482 4.84668 10.1991 5.141 10.1991 5.51558V10.4922L13.2226 12.2982C13.3471 12.3745 13.4433 12.4894 13.4967 12.6253C13.5501 12.7613 13.5577 12.9109 13.5184 13.0516C13.4791 13.1923 13.395 13.3163 13.2788 13.4049C13.1626 13.4934 13.0208 13.5417 12.8747 13.5424Z" fill="#000000"/>
                  </svg>
                )
              }
              <p className='flex-item fs-16 font-weight-700' style={{whiteSpace:"nowrap"}}>Leads Info</p>
            </div>,
            <div className="w-full" style={{height: window.innerWidth > 767 ? "83%" : "100%", padding:"0 16px 100px 16px", overflowY:"auto"}}>

              <div className='d-flex-wrap space-between'>
                <div onClick={toggleInputFields('first-name')} className={`${(currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "10px" : "14px", color: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "var(--darkBlue)" : "", transition: "180ms" }}>First Name <span className='color-red'>*</span></p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.name.firstName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter First Name' />
                </div>
                <div onClick={toggleInputFields('middle-name')} className={`${(currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "10px" : "14px", color: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Middle Name</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.name.middleName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Middle Name'/>
                </div>
                <div onClick={toggleInputFields('last-name')} className={`${(currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "10px" : "14px", color: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Last Name</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.name.lastName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Last Name' />
                </div>
              </div>

              <svg className='m-b-12 m-t-8' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
              </svg>

              <div className='d-flex-wrap w-full space-between'>
                <div className='enq-personal-details-container'>
                  <p className='fs-14 font-weight-700 m-b-12'>Personal Details</p>
                  <div onClick={toggleInputFields('birth-date')} className={`${(currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "10px" : "14px", color: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Birth Date</p>
                    </div>
                    <input ref={birthDateRef} value={userEnqDetails.personalDetails.birthDate} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                  </div>
                  <div className='d-flex m-t-20 m-b-16'>
                    <div onClick={()=> handleRadioAction("gender", "Male")} className='d-flex m-r-20'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Male" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Male</p>
                    </div>

                    <div onClick={()=> handleRadioAction("gender", "Female")} className='d-flex'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Female" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Female</p>
                    </div>
                  </div>
                  <div onClick={()=> handleRadioAction("gender", "Others")} className='d-flex'>
                    <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Others" ? true : false} />
                    <p className='flex-item font-weight-600 color-dark-blue fs-16'>Others</p>
                  </div>
                  <p className='fs-14 font-weight-700 m-b-12' style={{marginTop:window.innerWidth > 767 ? "46px" : "26px"}}>Marital Status</p>
                  <div className='d-flex m-b-16'>
                    <div onClick={()=> handleRadioAction("marital-status", "Single")} className='d-flex m-r-20'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-stats" checked={userEnqDetails.personalDetails.maritalStatus == "Single" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Single</p>
                    </div>

                    <div onClick={()=> handleRadioAction("marital-status", "Married")} className='d-flex'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-stats" checked={userEnqDetails.personalDetails.maritalStatus == "Married" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Married</p>
                    </div>
                  </div>
                  
                  <div onClick={toggleInputFields('anniversary-date')} className={`${(currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "1px solid var(--darkBlue)" : "", width: "100%", visibility: userEnqDetails.personalDetails.maritalStatus == "Married" ? "visible" : "hidden" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "10px" : "14px", color: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "#4d4d4d" : "", transition: "180ms" }}>Anniversary Date</p>
                    </div>
                    <input ref={anniversaryDateRef} value={userEnqDetails.personalDetails.anniversaryDate} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                  </div>
                </div>

                {
                  window.innerWidth > 767 ? (
                    <svg className='flex-item' width="3" height="350" viewBox="0 0 3 360" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="1.375" y1="360.002" x2="2.4637" y2="0.00355813" stroke="#ABABAB" stroke-dasharray="2 2"/>
                    </svg>
                  ) : (
                    <svg className='m-b-16 m-t-20' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
                    </svg>
                  )
                }
                
                <div className='enq-contact-details-container'>
                  <p className='fs-14 font-weight-700 m-b-12'>Contact Details</p>
                  
                  <div className='d-flex-wrap space-between'>
                    <div onClick={toggleInputFields('mobile-number')} className={`${(currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "10px" : "14px", color: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mobile Number <span className='color-red'>*</span></p>
                      </div>
                      <input onChange={handleChange} value={userEnqDetails.contactDetails.mobileNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00000-00000' />
                    </div>

                    <div onClick={toggleInputFields('landline-number')} className={`${(currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "10px" : "14px", color: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Landline Number</p>
                      </div>
                      <input onChange={handleChange} value={userEnqDetails.contactDetails.landLineNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00-0000-0000' />
                    </div>
                  </div>

                  <div className='d-flex-wrap space-between'>
                    <div onClick={toggleInputFields('emergency-contact-person')} className={`${(currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "10px" : "14px", color: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Person</p>
                      </div>
                      <input onChange={handleChange} value={userEnqDetails.contactDetails.emergencyContactPerson} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Name' />
                    </div>

                    <div onClick={toggleInputFields('emergency-contact-number')} className={`${(currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "10px" : "14px", color: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Number</p>
                      </div>
                      <input onChange={handleChange} value={userEnqDetails.contactDetails.emergencyContactNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00000-00000' />
                    </div>
                  </div>

                  <div onClick={toggleInputFields('email-address')} className={`${(currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "10px" : "14px", color: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "var(--darkBlue)" : "", transition: "180ms" }}>Email Address</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.contactDetails.emailAddress} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='example@gmail.com' />
                  </div>

                  <div onClick={toggleInputFields('residential-address')} className={`${(currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "10px" : "14px", color: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "var(--darkBlue)" : "", transition: "180ms" }}>Residential Address</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.contactDetails.residentialAddress} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='House/Flat No., Street, Locality, City' />
                  </div>

                  <div onClick={toggleInputFields('apartment-name')} className={`${(currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "10px" : "14px", color: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Apartment / Society Name</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.contactDetails.apartmentName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Your apartment or society (e.g., Rosewood Heights)' />
                  </div>

                </div>
                  
              </div>

              <svg className='m-t-16 m-b-20' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
              </svg>
              
              <p className='fs-14 font-weight-700 m-b-12'>Personal Fitness Status</p>
              
              <div className='d-flex-wrap space-between m-b-8'>
                <div onClick={toggleInputFields('health-challenges')} className={`${(currentElementId == 'health-challenges' || userEnqDetails.personalFitnessStatus.healthChallenges) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'health-challenges' || userEnqDetails.personalFitnessStatus.healthChallenges) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'health-challenges' || userEnqDetails.personalFitnessStatus.healthChallenges) ? "10px" : "14px", color: (currentElementId == 'health-challenges' || userEnqDetails.personalFitnessStatus.healthChallenges) ? "var(--darkBlue)" : "", transition: "180ms" }}>Health Challenges</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.personalFitnessStatus.healthChallenges} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'health-challenges' || userEnqDetails.personalFitnessStatus.healthChallenges) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Share any physical or medical conditions' />
                </div>

                <div onClick={toggleInputFields('fitness-goal')} className={`${(currentElementId == 'fitness-goal' || userEnqDetails.personalFitnessStatus.fitnessGoal) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'fitness-goal' || userEnqDetails.personalFitnessStatus.fitnessGoal) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'fitness-goal' || userEnqDetails.personalFitnessStatus.fitnessGoal) ? "10px" : "14px", color: (currentElementId == 'fitness-goal' || userEnqDetails.personalFitnessStatus.fitnessGoal) ? "var(--darkBlue)" : "", transition: "180ms" }}>Fitness Goal</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.personalFitnessStatus.fitnessGoal} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'fitness-goal' || userEnqDetails.personalFitnessStatus.fitnessGoal) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Your Fitness Goal' />
                </div>
              </div>

              <p className='fs-14 font-weight-700 m-b-12'>Are you exercising currently ?</p>

              <div className='d-flex'>
                <div onClick={()=> handleRadioAction("exercising", true)} className='d-flex m-r-20'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="exercising"  checked={userEnqDetails.personalFitnessStatus.exercising ? true : false } />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>Yes</p>
                </div>

                <div  onClick={()=> handleRadioAction("exercising", false)} className='d-flex'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="exercising" checked={!userEnqDetails.personalFitnessStatus.exercising ? true : false } />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>No</p>
                </div>
              </div>

              <svg className='m-t-20 m-b-20' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
              </svg>

              <p className='fs-14 font-weight-700 m-b-12'>Preferences & Services</p>

              <div className='d-flex-wrap space-between m-b-8'>

                <div onClick={toggleInputFields('gym-service')} className={`${currentElementId == 'gym-service' || userEnqDetails.gymPrefService.gymService ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'gym-service' || userEnqDetails.gymPrefService.gymService ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                  <div className='d-flex w-full space-between'>
                    <div className='flex-item'>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'gym-service' || userEnqDetails.gymPrefService.gymService ? "10px" : "", color: currentElementId == 'gym-service' || userEnqDetails.gymPrefService.gymService ? "var(--darkBlue)" : "", transition: "180ms" }}>Service <span className='color-red'>*</span></p>
                      </div>
                      <input readOnly value={userEnqDetails.gymPrefService.gymService} type="text" className={`${currentElementId == 'gym-service' || userEnqDetails.gymPrefService.gymService ? "active-input-field" : "inactive-input-field"}`} />
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ transform: isGymServiceListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    {
                      isGymServiceListOpen && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "All Services")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">All Services</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Gym Workout")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Workout</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Gym Workout With Recovery Session")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Workout With Recovery Session</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Gym Workout With Steam")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Workout With Steam</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Personal Training")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Personal Training</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Fitness Workout")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Fitness Workout</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Infrared Therapy")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Infrared Therapy</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Red Light Therapy")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Red Light Therapy</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Salt Therapy")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Salt Therapy</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Sauna")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Sauna</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Ice Bath / Cold Plunge")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Ice Bath / Cold Plunge</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Steam Bath")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Steam Bath</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Hatha Yoga")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Hatha Yoga</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Medical yoga")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Medical yoga</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Aerial yoga")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Aerial yoga</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "kids yoga")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">kids yoga</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "YTC")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">YTC</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("gym-service", "Others")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Others</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>

                <div onClick={toggleInputFields('commitment-date')} className={`${(currentElementId == 'commitment-date' || userEnqDetails.gymPrefService.commitmentDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'commitment-date' || userEnqDetails.gymPrefService.commitmentDate) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'commitment-date' || userEnqDetails.gymPrefService.commitmentDate) ? "10px" : "14px", color: (currentElementId == 'commitment-date' || userEnqDetails.gymPrefService.commitmentDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Commitment Date</p>
                  </div>
                  <input ref={commitmentDateRef} value={userEnqDetails.gymPrefService.commitmentDate} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'commitment-date' || userEnqDetails.gymPrefService.commitmentDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                </div>

              </div>

              <div className='d-flex'>
                <div className='flex-item d-flex'>
                  <p className='fs-14 font-weight-700 m-r-16'>Trial Booking</p>
                  <div onClick={()=>toggleTrialBooking()} className='toggle-button margin-auto d-flex cursor-pointer' style={{backgroundColor: isTrialBooking && "#B3E28F"}}>
                    <div className='toggle-ball flex-item' style={{margin: isTrialBooking ? "-2px 0 0 30px" : "-2px 0 0 -2px",  backgroundColor: isTrialBooking && "#5d883c"}} />
                  </div>
                </div>
              </div>
              
              {
                isTrialBooking && (
                  <div className='d-flex-wrap space-between m-t-16'>
                    <div onClick={toggleInputFields('trial-date-and-time')} className={`${(currentElementId == 'trial-date-and-time' || userEnqDetails.trialBooking.trialDateAndTime) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'trial-date-and-time' || userEnqDetails.trialBooking.trialDateAndTime) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'trial-date-and-time' || userEnqDetails.trialBooking.trialDateAndTime) ? "10px" : "14px", color: (currentElementId == 'trial-date-and-time' || userEnqDetails.trialBooking.trialDateAndTime) ? "var(--darkBlue)" : "", transition: "180ms" }}>Trial Date & Time</p>
                      </div>
                      <input ref={trialDateAndTimeRef} readOnly value={userEnqDetails.trialBooking.trialDateAndTime ? new Date(userEnqDetails.trialBooking.trialDateAndTime).toLocaleString() : ""} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'trial-date-and-time' || userEnqDetails.trialBooking.trialDateAndTime) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD  HH:MM' />
                    </div>

                    <div onClick={toggleInputFields('assign-to-employee')} className={`${currentElementId == 'assign-to-employee' || userEnqDetails.trialBooking.assignTo ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'assign-to-employee' || userEnqDetails.trialBooking.assignTo ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'assign-to-employee' || userEnqDetails.trialBooking.assignTo ? "10px" : "", color: currentElementId == 'assign-to-employee' || userEnqDetails.trialBooking.assignTo ? "var(--darkBlue)" : "", transition: "180ms" }}>Assign To</p>
                          </div>
                          <input value={userEnqDetails.trialBooking.assignTo?.name || ""} type="text" className={`${currentElementId == 'assign-to-employee' || userEnqDetails.trialBooking.assignTo ? "active-input-field" : "inactive-input-field"}`} />
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ transform: isAssignToListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                        {
                          isAssignToListOpen && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" style={{overflowY:"auto"}}>
                            {
                              Users.map(data=>{
                                return (
                                  <div onClick={()=>handleSelectDropdownItem("assign-to-employee", data)} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">{data.name}</p>
                                  </div>
                                )
                              })
                            }
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                )
              }

              <svg className='m-b-20' style={{marginTop: isTrialBooking ? "8px" : "20px"}} width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
              </svg>

              <p className='fs-14 font-weight-700 m-b-12'>Leads & Referral information</p>
              
              <div className='d-flex-wrap space-between'>

                <div onClick={toggleInputFields('lead-type')} className={`${currentElementId == 'lead-type' || userEnqDetails.leadAndReferral.leadType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'lead-type' || userEnqDetails.leadAndReferral.leadType ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "32%" : "100%" }}>
                  <div className='d-flex w-full space-between'>
                    <div className='flex-item'>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'lead-type' || userEnqDetails.leadAndReferral.leadType ? "10px" : "", color: currentElementId == 'lead-type' || userEnqDetails.leadAndReferral.leadType ? "var(--darkBlue)" : "", transition: "180ms" }}>Lead Type <span className='color-red'>*</span></p>
                      </div>
                      <input readOnly value={userEnqDetails.leadAndReferral.leadType} type="text" className={`${currentElementId == 'lead-type' || userEnqDetails.leadAndReferral.leadType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select the type of lead" />
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ transform: isLeadTypeOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    {
                      isLeadTypeOpen && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          <div onClick={()=>handleSelectDropdownItem("lead-type", "Hot")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Hot</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("lead-type", "Warm")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Warm</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("lead-type", "Cold")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Cold</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>

                <div onClick={toggleInputFields('user-referral')} className={`${currentElementId == 'user-referral' || userEnqDetails.leadAndReferral.memberEmployeeReferral ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'user-referral' || userEnqDetails.leadAndReferral.memberEmployeeReferral ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "32%" : "100%"  }}>
                  <div className='d-flex w-full space-between'>
                    <div className='flex-item'>
                      <div className="flex-item d-flex">
                        {/* Member/Employee Referral */}
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'user-referral' || userEnqDetails.leadAndReferral.memberEmployeeReferral ? "10px" : "", color: currentElementId == 'user-referral' || userEnqDetails.leadAndReferral.memberEmployeeReferral ? "var(--darkBlue)" : "", transition: "180ms" }}>Employee Referral</p>
                      </div>
                      <input onChange={handleChange} value={userEnqDetails.leadAndReferral.memberEmployeeReferral?.name || ""} type="text" className={`${currentElementId == 'user-referral' || userEnqDetails.leadAndReferral.memberEmployeeReferral ? "active-input-field" : "inactive-input-field"}`} placeholder="Type / Select name" />
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ transform: isReferralUserListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    {
                      isReferralUserListOpen && (
                        <div onScroll={handleScrollUserList} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" >
                          {
                            Users.map(data=>{
                              return (
                                <div onClick={()=>handleSelectDropdownItem("user-referral", data)} className="global-input-field-arrow-dropdown-item">
                                  <p className="flex-item">{data.name}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                    }
                  </div>
                </div>

                <div onClick={toggleInputFields('other-referral')} className={`${(currentElementId == 'other-referral' || userEnqDetails.leadAndReferral.otherReferral) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'other-referral' || userEnqDetails.leadAndReferral.otherReferral) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "100%"  }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'other-referral' || userEnqDetails.leadAndReferral.otherReferral) ? "10px" : "14px", color: (currentElementId == 'other-referral' || userEnqDetails.leadAndReferral.otherReferral) ? "var(--darkBlue)" : "", transition: "180ms" }}>Other Referral</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.leadAndReferral.otherReferral} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'other-referral' || userEnqDetails.leadAndReferral.otherReferral) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='E.g., Rajesh Sharma (Employee)' />
                </div>

              </div>

              <p className='fs-14 font-weight-700 m-t-8 m-b-12'>Where did you hear about us ?</p>
              
              <div onClick={toggleInputFields('lead-source')} className={`${currentElementId == 'lead-source' || userEnqDetails.leadAndReferral.leadSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item"}`} style={{ border: currentElementId == 'lead-source' || userEnqDetails.leadAndReferral.leadSource ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "32%" : "100%", height:"40px" }}>
                <div className='d-flex w-full space-between'>
                  <input className='flex-item' readOnly value={userEnqDetails.leadAndReferral.leadSource} type="text" style={{marginTop: "5px"}} placeholder='Select Lead Source' />
                  <div className='input-field-arrow-dropdown' style={{ transform: isLeadSourceListOpen ? "rotate(180deg)" : "", margin: "9px 12px 0 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  {
                    isLeadSourceListOpen && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Google or other search")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Google or other search</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Word of mouth")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Word of mouth</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Hoarding")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Hoarding</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Article or Blog post")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Article or Blog post</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Social Media")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Social Media</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Radio")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Radio</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Television")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Television</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Just Dial")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Just Dial</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Magazine/Newspaper")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Magazine/Newspaper</p>
                        </div>
                        <div onClick={()=>handleSelectDropdownItem("lead-source", "Others")} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">Others</p>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>

              <svg className='m-t-20 m-b-20' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
              </svg>

              <p className='fs-14 font-weight-700 m-b-12'>Personal Traits & Budget</p>
              
              <div className='d-flex-wrap m-b-8'>
                <div onClick={toggleInputFields('personality-type')} className={`${currentElementId == 'personality-type' || userEnqDetails.personalTraitAndBudget.personalityType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'personality-type' || userEnqDetails.personalTraitAndBudget.personalityType ? "1px solid var(--darkBlue)" : "",  width: window.innerWidth > 767 ? "32%" : "100%", marginRight:window.innerWidth > 767 && "16px" }}>
                  <div className='d-flex w-full space-between'>
                    <div className='flex-item'>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'personality-type' || userEnqDetails.personalTraitAndBudget.personalityType ? "10px" : "", color: currentElementId == 'personality-type' || userEnqDetails.personalTraitAndBudget.personalityType ? "var(--darkBlue)" : "", transition: "180ms" }}>Personality Type</p>
                      </div>
                      <input readOnly value={userEnqDetails.personalTraitAndBudget.personalityType} type="text" className={`${currentElementId == 'personality-type' || userEnqDetails.personalTraitAndBudget.personalityType ? "active-input-field" : "inactive-input-field"}`} />
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ transform: isPersonalityTypeListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    {
                      isPersonalityTypeListOpen && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          <div onClick={()=>handleSelectDropdownItem("personality-type", "Gym Donor")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Donor</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("personality-type", "Gym Goer")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Goer</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("personality-type", "Gym Excuser")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Gym Excuser</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>

                <div onClick={toggleInputFields('budget')} className={`${(currentElementId == 'budget' || userEnqDetails.personalTraitAndBudget.budget) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'budget' || userEnqDetails.personalTraitAndBudget.budget) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'budget' || userEnqDetails.personalTraitAndBudget.budget) ? "10px" : "14px", color: (currentElementId == 'budget' || userEnqDetails.personalTraitAndBudget.budget) ? "var(--darkBlue)" : "", transition: "180ms" }}>Budget/month (Rs.)</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.personalTraitAndBudget.budget} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'budget' || userEnqDetails.personalTraitAndBudget.budget) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
              </div>

              <div onClick={toggleInputFields('remark')} className={`${(currentElementId == 'remark' || userEnqDetails.remark) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'remark' || userEnqDetails.remark) ? "1px solid var(--darkBlue)" : "", width: "100%", height:"100px" }}>
                <div className="d-flex m-t-6" style={{alignSelf:"flex-start"}}>
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'remark' || userEnqDetails.remark) ? "10px" : "14px", color: (currentElementId == 'remark' || userEnqDetails.remark) ? "var(--darkBlue)" : "", transition: "180ms" }}>Remark/Summary</p>
                </div>
                <textarea onChange={handleChange} value={userEnqDetails.remark} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'remark' || userEnqDetails.remark) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter your fitness goal' />
              </div>
              
              {
                !props.selectedUsers && [
                  <div onClick={()=>handleAddNewFollowup()} className='d-flex m-t-20 cursor-pointer'>
                    <input className='flex-item m-r-8' type="checkbox" checked={isAddNewFollowup} style={{padding:0, width:"20px", height:"20px"}} />
                    <p className='flex-item font-weight-700'>Add Follow-Up</p>
                  </div>,
                  isAddNewFollowup && (
                    <div className='w-full m-t-12'>
                      <div className='d-flex m-b-12'>
                        <div onClick={toggleInputFields('followup-date')} className={`${(currentElementId == 'followup-date' || followUps.followUpDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: (currentElementId == 'followup-date' || followUps.followUpDate) ? "1px solid var(--darkBlue)" : "", width: "30%" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'followup-date' || followUps.followUpDate) ? "10px" : "14px", color: (currentElementId == 'followup-date' || followUps.followUpDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Follow-Up Date <span className='color-red'>*</span></p>
                          </div>
                          <input ref={followUpDateRef} value={followUps.followUpDateDisplay} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'followup-date' || followUps.followUpDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                        </div>
                        <div onClick={toggleInputFields('followup-type')} className={`${currentElementId == 'followup-type' || followUps.followUpType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'followup-type' || followUps.followUpType ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "40%" : "100%" }}>
                          <div className='d-flex w-full space-between'>
                            <div className='flex-item'>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'followup-type' || followUps.followUpType ? "10px" : "", color: currentElementId == 'followup-type' || followUps.followUpType ? "var(--darkBlue)" : "", transition: "180ms" }}>Follow-Up Type <span className='color-red'>*</span></p>
                              </div>
                              <input readOnly value={followUps.followUpType} type="text" className={`${currentElementId == 'followup-type' || followUps.followUpType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select the type of lead" />
                            </div>
                            <div className='input-field-arrow-dropdown' style={{ transform: isFollowUpTypeListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                              </svg>
                            </div>
                            {
                              isFollowUpTypeListOpen && (
                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Anniversary Wish")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Anniversary Wish</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Balance Due")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Balance Due</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Birthday Wish")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Birthday Wish</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Commitment")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Commitment</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Enquiry")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Enquiry</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Feedback")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Feedback</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Freeze")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Freeze</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Irregular Member")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Irregular Member</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Membership Renewal")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Membership Renewal</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Measurement")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Measurement</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "P.T. Renewal")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">P.T. Renewal</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Regular Member")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Regular Member</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("followup-type", "Other")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Other</p>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </div>                  
                      </div>
                      <div onClick={toggleInputFields('followup-todo')} className={`${(currentElementId == 'followup-todo' || followUps.todo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'followup-todo' || followUps.todo) ? "1px solid var(--darkBlue)" : "", width: "100%", height:"100px" }}>
                        <div className="d-flex m-t-6" style={{alignSelf:"flex-start"}}>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'followup-todo' || followUps.todo) ? "10px" : "14px", color: (currentElementId == 'followup-todo' || followUps.todo) ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment <span className='color-red'>*</span></p>
                        </div>
                        <textarea onChange={handleChange} value={followUps.todo} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'followup-todo' || followUps.todo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Type Member Follow-Up Comment' />
                      </div>
                      <div className='d-flex space-between'>
                        <div onClick={toggleInputFields('assign-to')} className={`${currentElementId == 'assign-to' || followUps.assignTo ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'assign-to' || followUps.assignTo ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "48%" : "100%"  }}>
                          <div className='d-flex w-full space-between'>
                            <div className='flex-item'>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'assign-to' || followUps.assignTo ? "10px" : "", color: currentElementId == 'assign-to' || followUps.assignTo ? "var(--darkBlue)" : "", transition: "180ms" }}>Assign To <span className='color-red'>*</span></p>
                              </div>
                              <input onChange={handleChange} value={followUps.assignTo?.name || ""} type="text" className={`${currentElementId == 'assign-to' || followUps.assignTo ? "active-input-field" : "inactive-input-field"}`} placeholder="Type / Select name" />
                            </div>
                            <div className='input-field-arrow-dropdown' style={{ transform: isAssignToUserListOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                              </svg>
                            </div>
                            {
                              isAssignToUserListOpen && (
                                <div onScroll={handleScrollUserList} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" >
                                  {
                                    Users.map(data=>{
                                      return (
                                        <div onClick={()=>handleSelectDropdownItem("assign-to", data)} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">{data.name}</p>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              )
                            }
                          </div>
                        </div>
                        <div onClick={toggleInputFields('convertibility-followup-type')} className={`${currentElementId == 'convertibility-followup-type' || followUps.convertibility ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'convertibility-followup-type' || followUps.convertibility ? "1px solid #5D883C" : "",  width: window.innerWidth > 767 ? "48%" : "100%" }}>
                          <div className='d-flex w-full space-between'>
                            <div className='flex-item'>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'convertibility-followup-type' || followUps.convertibility ? "10px" : "", color: currentElementId == 'convertibility-followup-type' || followUps.convertibility ? "var(--darkBlue)" : "", transition: "180ms" }}>Convertibility <span className='color-red'>*</span></p>
                              </div>
                              <input readOnly value={followUps.convertibility} type="text" className={`${currentElementId == 'convertibility-followup-type' || followUps.convertibility ? "active-input-field" : "inactive-input-field"}`} placeholder="Select the type of lead" />
                            </div>
                            <div className='input-field-arrow-dropdown' style={{ transform: isFollowUpConvertibilityTypeOpen ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                              </svg>
                            </div>
                            {
                              isFollowUpConvertibilityTypeOpen && (
                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                  <div onClick={()=>handleSelectDropdownItem("convertibility-followup-type", "Hot")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Hot</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("convertibility-followup-type", "Warm")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Warm</p>
                                  </div>
                                  <div onClick={()=>handleSelectDropdownItem("convertibility-followup-type", "Cold")} className="global-input-field-arrow-dropdown-item">
                                    <p className="flex-item">Cold</p>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ]
              }

            </div>
          ]
        }

        {
          isBulkUpload  && (
            <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
              <div onClick={()=>alert(`This feature is currently under development. Our team will notify you as soon as it’s live.\nWe apologize for any inconvenience caused and appreciate your patience.`)} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
                <p className="flex-item">Add Bulk Enquiry</p>
              </div>
            </div>
          )
        }
        
        {
          (progressTracker.personalInfo && progressTracker.gymService && progressTracker.leadsInfo) && (
            isAddNewFollowup ? (
              followUps.followUpDate && followUps.followUpType && followUps.todo && followUps.assignTo && followUps.convertibility && ( 
                <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
                  <div onClick={isButtonLock?null:SaveEnquiry} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
                    <p className="flex-item">{props.selectedUsers ? "Update" : enquiryType == "new-sales" ? "Save & Continue" : "Create Enquiry"}</p>
                  </div>
                </div>
              )
            ) : (
              <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
                <div onClick={isButtonLock?null:SaveEnquiry} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
                  <p className="flex-item">{props.selectedUsers ? "Update" : enquiryType == "new-sales" ? "Save & Continue" : "Create Enquiry"}</p>
                </div>
              </div>
            )

          )
        }
      </div>
    </div>
  )
}

export default ManageEnquiry;